export const NPS_SUMMARY_REPORT = 'NPS Summary Report V4';
export const NPS_SUMMARY_REPORT_MESSAGE =
  'Displays the NPS Summary Report V4 for the date range provided';
export const NPS_SUMMARY_REPORT_TITLE = "npsSummaryReportV4";

export const groupingOptions = ['Week', 'Month', 'Year'];
export const highlightedFields = [
  'totalResponses',
  'totalResponsesPercentage',
  'totalRows',
  'npsScore',
  'detractor',
  'detractorPercentage',
  'passive',
  'passivePercentage',
  'promotor',
  'promotorPercentage',
 ] as const;

export const defaultColumns = [
  { name: 'siteName', title: 'Repairer Name' },
  { name: 'totalRows', title: 'Total Surveys' },
  {
    title: 'Total Response',
    children: [
      {
        name: 'totalResponses',
        title: 'Count',
      },
      {
        name: 'totalResponsesPercentage',
        title: '%',
      },
    ],
  },
  {
    title: 'Detractor',
    children: [
      {
        name: 'detractor',
        title: 'Count',
      },
      {
        name: 'detractorPercentage',
        title: '%',
      },
    ],
  },
  {
    title: 'Passive',
    children: [
      {
        name: 'passive',
        title: 'Count',
      },
      {
        name: 'passivePercentage',
        title: '%',
      },
    ],
  },
  {
    title: 'Promotor',
    children: [
      {
        name: 'promotor',
        title: 'Count',
      },
      {
        name: 'promotorPercentage',
        title: '%',
      },
    ],
  },
  { name: 'npsScore', title: 'NPS Score' },
  { name: 'repairerGroup', title: 'Repairer Group', width: '150' },
];

export const summaryItems = [
  { columnName: 'siteName', type: 'sum', customizeText: () => `Grand Total` },
  { columnName: 'totalRows', type: 'sum' },
  { columnName: 'totalResponses', type: 'sum' },
  { columnName: 'totalResponsesPercentage', type: 'custom' },
  { columnName: 'detractor', type: 'sum' },
  { columnName: 'detractorPercentage', type: 'custom' },
  { columnName: 'passive', type: 'sum' },
  { columnName: 'passivePercentage', type: 'custom' },
  { columnName: 'promotor', type: 'sum' },
  { columnName: 'promotorPercentage', type: 'custom' },
  { columnName: 'npsScore', type: 'custom' },
];

export const reportsColors = {
  totalRows: 'fa8072',
  totalResponses: 'f5f5f5',
  totalResponsesPercentage: 'f5f5f5',
  detractor: 'ffe4e1',
  detractorPercentage: 'ffe4e1',
  promotor: '20b2aa',
  promotorPercentage: '20b2aa',
  passive: 'fffacd',
  passivePercentage: 'fffacd',
  npsScore: 'fffff0',
  npsScoreRange1: '90EE90', //Above 25
  npsScoreRange2: 'FFA500', //0 to 25
  npsScoreRange3: 'FFC0CB', //Negative Numbers
};
